import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { clientsSelector, currentClientStatusSelector, allReadersInfoSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listClients } from 'redux/modules/model/client'
import { listAllReaders } from 'redux/modules/model/site';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch) ||
            item.siteId.toUpperCase().includes(ucSearch) ||
            item.readerSn.toUpperCase().includes(ucSearch) ||
            item.agentId.toUpperCase().includes(ucSearch)
    }
    return true
}

class ReaderList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listClients: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        clientList: PropTypes.array.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, listClients, logUserTab, listAllReaders } = this.props
        listClients({ clientId })
        listAllReaders({ clientId })
        const tab = "Reader"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { clientList, operatorListStatus, location, readers } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        const filteredReaders = fp.filter(predicate(criteria))(readers)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView readers={filteredReaders} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load readers</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    clientList: clientsSelector,
    operatorListStatus: currentClientStatusSelector,
    readers: allReadersInfoSelector
})

export const actions = {
    listClients,
    listAllReaders,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(ReaderList)



// WEBPACK FOOTER //
// ./src/pages/reader/reader-list/index.js